module.exports = __webpack_public_path__ + "static/media/16․05.d4482f6b.webp";